export default "/_next/static/videos/d94b5516f4fcee119d39b16b6f9c3fc3.mp4";